import { FC } from "react";
import { useTranslation } from "react-i18next";

import { InputDateYearSmall } from "@/components/_molecules/input-date/input-date-year-small";
import { maxReferenceYear } from "@/domain/inventory/lib/reference-year";

interface ReferenceYearFieldProps {
  referenceYear: number | null;
  inventoryYear: number;
  cellKey: string;
  isEditing: boolean;
  onChange: (referenceYear: number | null) => void;
}

export const ReferenceYearField: FC<ReferenceYearFieldProps> = ({
  referenceYear,
  inventoryYear,
  cellKey,
  isEditing,
  onChange,
}) => {
  const { t } = useTranslation("inventory");

  return (
    <div className="flex flex-row items-start gap-3 pl-2 text-sm text-muted-foreground">
      <div className="mt-2 w-24 shrink-0 font-medium">{t("gpcEmissionFactorRightAside.referenceYear")}</div>
      {isEditing ? (
        <InputDateYearSmall
          key={`refyear-${cellKey}-${referenceYear ?? ""}`}
          defaultValue={referenceYear ?? undefined}
          placeholder={String(inventoryYear)}
          maxYear={maxReferenceYear()}
          clearable
          onValueChange={onChange}
          className="mt-1 w-full flex-1"
        />
      ) : (
        <span className="mt-2 block flex-1 truncate text-sm">{referenceYear ?? "-"}</span>
      )}
    </div>
  );
};
